import { Plus, Trash2 } from 'lucide-react';

import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export function EnumEditor(props: { values: string[]; onChange: (next: string[]) => void; disabled?: boolean }) {
  const { values, onChange, disabled = false } = props;

  return (
    <div className="space-y-3 rounded-xl border p-3">
      <div className="flex items-center justify-between">
        <Label>Allowed values (optional)</Label>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={() => onChange([...(values ?? []), 'value'])}
          disabled={disabled}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add value
        </Button>
      </div>

      {(values?.length ?? 0) === 0 ? (
        <p className="text-muted-foreground text-sm">No allowed values.</p>
      ) : (
        <div className="space-y-2">
          {(values ?? []).map((val, idx) => (
            <div key={`${idx}`} className="flex gap-2">
              <Input
                value={val}
                onChange={(e) => {
                  const next = [...values];
                  next[idx] = e.target.value;
                  onChange(next);
                }}
                disabled={disabled}
              />
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  const next = [...values];
                  next.splice(idx, 1);
                  onChange(next);
                }}
                disabled={disabled}
              >
                <Trash2 className="mr-2 h-4 w-4" />
                Remove
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
